/* eslint-disable react/jsx-no-useless-fragment */
import React, { useMemo, useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import request from 'meinian-package/src/utils/request'
import qs from 'qs'
import { TiledMark } from 'component/filter/mark'
import { TiledPlatform } from 'component/filter/platform'
import ElementSelect from 'component/filter/element'
import DatePicker from 'meinian-package/src/component/datePicker'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import Button from 'meinian-package/src/baseComponent/button'
import { StyleTypeSelect } from 'component/filter/styleType'
import { NewPriceZoneRange } from 'component/filter/priceZone/priceZoneRange'
import { NewShopType } from 'component/filter/shopType'
import { getIndustry } from 'component/util'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import { useClickAway } from 'ahooks'
import GenderAndCategory from 'component/filter/genderAndCategory/newCategory'
import AddPanelSelect, { SEARCH_TYPE } from 'baseComponent/select/panelSelect'
import DropDownClearIcon from 'meinian-package/src/baseComponent/dropDownClearIcon'
import globalData from 'meinian-package/src/common/globalData'
import styles from './index.module.less'

export default ({
  hasFilter,
  setHasFilter,
  currentData = {},
  visible,
  value = {},
  onChange,
  onCancel,
  hiddenChildFlag = true,
  defaultParams = {},
  displayTextClassName,
}) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [params, setParams] = useState(value)
  const domRef = useRef(null)
  useClickAway(() => {
    if (visible) {
      onCancel()
    }
  }, domRef)

  const _style = useMemo(() => {
    if (visible) {
      return {
        maxHeight: 534,
        opacity: 1,
        marginBottom: 24
      }
    }
    return {
      maxHeight: 0,
      opacity: 0,
      marginBottom: 0
    }
  }, [visible])

  const changeGenderAndCategory = (gender, category) => {
    setParams({ ...params, gender, category, element: {} })
  }

  const count = useMemo(() => {
    const keys = [
      ['markStatus', 'markTimes'],
      ['platformIdList'],
      ['blogTimeStart', 'blogTimeEnd'],
      ['submitTimeStart', 'submitTimeEnd'],
      ['createdTimeStart', 'createdTimeEnd'],
      ['markPassTimeStart', 'markPassTimeEnd'],
      ['userIdList'],
      ['markUserList'],
      ['annotationUserList'],
      ['annotationFlag'],
      ['clothFlag'],
      ['dontShowSubInspiration'],
      ['category', 'gender'],
      ['element'],
      ['commentFlag'],
      ['shopType'],
      ['styleType'],
      ['priceStart', 'priceEnd'],
      ['tagIdList'],
      ['sourceShopNames']
    ]
    const _params = params
    let _count = 0
    keys.forEach(countKey => {
      if (countKey.some(key => {
        if (Array.isArray(_params[key])) {
          return _params[key].length
        }
        if (JSON.stringify(_params[key]) === '{}') {
          return false
        }
        return _params[key]
      })) {
        _count += 1
      }
      if (!countKey.length) {
        const flatKeys = keys.flat()
        const otherKeys = Object.keys(_params).filter(_key => !flatKeys.includes(_key))
        const flag = otherKeys.some(_key => {
          if (Array.isArray(_params[_key])) {
            return _params[_key].length
          }
          if (JSON.stringify(_params[_key]) === '{}') {
            return false
          }
          return _params[_key]
        })
        if (flag) {
          _count += 1
        }
      }
    })
    return _count
  }, [params])

  return <div ref={domRef}>
    <div className={classNames(styles.operationLabelText)}>
      <div className={classNames('operationLabelTextWrap', 'dropDownClearIcon', displayTextClassName, { active: visible, clear: count })} style={{ marginRight: '8px', padding: '0 8px' }} onClick={() => setHasFilter((pre) => !pre)}>
        <DropDownClearIcon
          visible={hasFilter}
          onClear={() => {
            globalData.set('mn:inspirationParams:dontShowSubInspiration', 0)
            setParams(defaultParams)
            onChange(defaultParams)
            onCancel()
          }}
        >
          <>
            全部筛选
            {
              !!count && <div className="operationLabelTextNum">{count}</div>
            }
          </>
        </DropDownClearIcon>
      </div>
    </div>
    <div
      className={classNames(styles['meinian-home-all-style-filter'])}
      style={_style}
    >
      <div className="meinian-home-all-style-content">
        <TiledMark
          inspirationId={currentData.inspirationId}
          needMarkTimes={currentData.needMarkTimes}
          value={params.markStatus}
          otherValue={params.markTimes}
          onChange={(markStatus, item) => setParams(pre => ({ ...pre, markStatus, markTimes: item?.markTimes }))}
        />
        <TiledPlatform
          value={params?.platformIdList?.length ? params.platformIdList.join(',') : null}
          onChange={platformIdList => {
            setParams(pre => ({ ...pre, platformIdList: platformIdList ? String(platformIdList)?.split(',') : undefined, element: {}, shopType: null }))
          }}
        />
        <div className="content-line">
          <div className="content-line-label">时间筛选</div>
          <div className="date-collect-filter">
            <div style={{ marginRight: '8px' }}>采集时间:</div>
            <DatePicker
              textStyle={{ maxWidth: '132px' }}
              startTime={params.createdTimeStart}
              endTime={params.createdTimeEnd}
              noneText="不限"
              onChange={([createdTimeStart, createdTimeEnd]) => setParams(pre => ({ ...pre, createdTimeStart, createdTimeEnd }))}
              overlayProps={{
                onClick: e => e.stopPropagation()
              }}
            />
          </div>
          <div className="date-collect-filter">
            <div style={{ marginRight: '8px' }}>提审时间:</div>
            <DatePicker
              textStyle={{ maxWidth: '132px' }}
              startTime={params.submitTimeStart}
              endTime={params.submitTimeEnd}
              noneText="不限"
              onChange={([submitTimeStart, submitTimeEnd]) => {
                setParams(pre => ({ ...pre, submitTimeStart, submitTimeEnd }))
              }}
              overlayProps={{
                onClick: e => e.stopPropagation()
              }}
            />
          </div>
          <div className="date-collect-filter">
            <div style={{ marginRight: '8px' }}>通过时间:</div>
            <DatePicker
              textStyle={{ maxWidth: '132px' }}
              startTime={params.markPassTimeStart}
              endTime={params.markPassTimeEnd}
              noneText="不限"
              onChange={([markPassTimeStart, markPassTimeEnd]) => {
                setParams(pre => ({ ...pre, markPassTimeStart, markPassTimeEnd }))
              }}
              overlayProps={{
                onClick: e => e.stopPropagation()
              }}
            />
          </div>
          <div className="date-collect-filter">
            <div style={{ marginRight: '8px' }}>发布上架时间:</div>
            <DatePicker
              textStyle={{ maxWidth: '132px' }}
              startTime={params.blogTimeStart}
              endTime={params.blogTimeEnd}
              noneText="不限"
              onChange={([blogTimeStart, blogTimeEnd]) => setParams(pre => ({ ...pre, blogTimeStart, blogTimeEnd }))}
              overlayProps={{
                onClick: e => e.stopPropagation()
              }}
            />
          </div>
        </div>
        <div className="content-line" style={{ marginTop: '18px' }}>
          <div className="content-line-label">成员筛选</div>
          <CollectUser
            inspirationId={currentData.inspirationId}
            value={params.userIdList}
            onChange={(userIdList) => {
              setParams(pre => ({ ...pre, userIdList, }))
            }}
          />
          <CommentUser
            inspirationId={currentData.inspirationId}
            value={params.annotationUserList}
            onChange={annotationUserList => setParams(pre => ({ ...pre, annotationUserList }))}
          />
        </div>
        <div className="content-line" style={{ marginTop: '18px' }}>
          <div className="content-line-label">过滤筛选</div>
          {
            hiddenChildFlag && <Checkbox
              style={{ marginRight: '40px' }}
              checked={params.dontShowSubInspiration}
              onChange={(e) => {
                setParams(pre => ({
                  ...pre,
                  dontShowSubInspiration: e.target.checked ? 1 : 0
                }))
                globalData.set('mn:inspirationParams:dontShowSubInspiration', e.target.checked ? 1 : 0)
              }}
            >不看子灵感集</Checkbox>
          }
          <Checkbox
            checked={params.annotationFlag}
            onChange={(e) => {
              setParams(pre => ({
                ...pre,
                annotationFlag: e.target.checked ? 1 : null
              }))
            }}
            style={{ marginRight: '40px' }}
          >只看批注款式</Checkbox>
          <Checkbox
            checked={params.clothFlag}
            onChange={(e) => {
              setParams(pre => ({
                ...pre,
                clothFlag: e.target.checked ? 1 : null
              }))
            }}
            style={{ marginRight: '40px' }}
          >生成过样衣</Checkbox>
          <Checkbox
            checked={params.commentFlag}
            onChange={(e) => {
              setParams(pre => ({
                ...pre,
                commentFlag: e.target.checked ? 1 : null
              }))
            }}
            style={{ marginRight: '40px' }}
          >只看评论款式</Checkbox>
        </div>
        <div className="content-line" style={{ marginTop: '18px' }}>
          <div className="content-line-label">其他筛选</div>
          { +(params.platformIdList?.[0] || '') == PLATFORM_VALUE.ITEM
            ? <div style={{ marginRight: '40px' }}>
              <NewShopType
                value={params.shopType}
                onChange={shopType => setParams(pre => ({ ...pre, shopType }))}
              /></div> : null}
          <div style={{ flex: '1', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
            <div style={{ marginRight: '40px' }}>
              <GenderAndCategory
                gender={params.gender}
                value={params.category}
                onChange={(cur, root) => {
                  if (cur === root) {
                    changeGenderAndCategory(root, null)
                  } else {
                    changeGenderAndCategory(root, cur)
                  }
                }}
                shopStatus={+(params.platformIdList?.[0] || '') == PLATFORM_VALUE.ITEM ? 1 : 0}
              />
            </div>
            <div style={{ marginRight: '40px' }}>
              <ElementSelect
                value={params.element}
                onChange={element => {
                  setParams(pre => ({ ...pre, element }))
                }}
                platformId={params.platformIdList?.[0]}
                industry={getIndustry(params.gender)}
                disabled={!(params.gender || params.category)}
              />
            </div>
            <div style={{ marginRight: '40px' }}>
              <StyleTypeSelect value={params.styleType} onChange={val => setParams(pre => ({ ...pre, styleType: val }))} />
            </div>
            <div style={{ marginRight: '40px' }}>
              <NewPriceZoneRange
                value={[params.priceStart, params.priceEnd]}
                onChange={val => setParams(pre => ({ ...pre, priceStart: val[0], priceEnd: val[1] }))}
              />
            </div>
            <CustomTag
              inspirationId={currentData.inspirationId}
              value={params.tagIdList}
              onChange={(tagIdList) => {
                setParams(pre => ({ ...pre, tagIdList }))
              }}
            />
            <Publisher
              keywords={query.publishKeyword}
              inspirationId={currentData.inspirationId}
              value={params.sourceShopNames}
              onChange={(sourceShopNames, hasInit) => {
                const platformIdList = query.platformId && !params.platformIdList ? [query.platformId] : params.platformIdList
                setParams(pre => ({ ...pre, sourceShopNames, platformIdList }))
                if (hasInit) {
                  onChange({ ...params, sourceShopNames, platformIdList })
                }
              }}
            />
          </div>
        </div>
      </div>
      <div className="meinian-home-all-style-filter-footer">
        <div className="meinian-home-all-style-filter-footer-btn-wrap">
          {
            !!count && <div
              className="meinian-home-all-style-filter-footer-btn-clear"
              onClick={(e) => {
                e.stopPropagation()
                setParams(defaultParams)
              }}
            >清空筛选</div>
          }
          <Button
            style={{ width: '80px', marginRight: '8px' }}
            onClick={() => {
              onCancel()
            }}
          >取消</Button>
          <Button
            type="primary"
            style={{ width: '80px' }}
            onClick={() => {
              onChange(params)
              onCancel()
            }}
          >确定</Button>
        </div>
      </div>
    </div>
  </div>
}

const CollectUser = ({ inspirationId, value, onChange }) => {
  const [options, setOptions] = useState([])
  const convert = (result) => {
    return result.map(m => ({ label: m.userName, value: m.userId }))
  }
  useEffect(() => {
    fetchUsers()
  }, [inspirationId])
  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/user-selector', { params: { inspirationId } })
      setOptions(res)
    } catch (err) {
      console.error(err)
    }
  }
  return <AddPanelSelect
    panelLabel="成员"
    value={value}
    onChange={onChange}
    convert={convert}
    options={options}
    style={{ marginRight: '40px' }}
    label="采集成员："
  />
}

const CommentUser = ({ inspirationId, value, onChange }) => {
  const convert = (result) => {
    return result.map(m => ({ label: m.userName, value: m.userId }))
  }
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchUsers()
  }, [inspirationId])

  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/user-selector', { params: { inspirationId } })
      setOptions(res)
    } catch (err) {
      console.error(err)
    }
  }
  return <AddPanelSelect
    panelLabel="成员"
    value={value}
    onChange={onChange}
    options={options}
    convert={convert}
    style={{ marginRight: '40px' }}
    label="批注成员："
  />
}

const CustomTag = ({ inspirationId, value, onChange }) => { // 自定义标签
  const convert = (result) => {
    return result.map(m => ({ label: m.tagName, value: m.tagId }))
  }
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchTags()
  }, [inspirationId])

  const fetchTags = async () => {
    try {
      const res = await request.spost('/zhikuan/img-tag/selector', { inspirationId }, 'MNTagSearch')
      setOptions(res)
    } catch (err) {
      console.error(err)
    }
  }
  return <AddPanelSelect
    panelLabel="标签"
    options={options}
    value={value}
    onChange={onChange}
    convert={convert}
    style={{ marginRight: '40px' }}
    label="自定义标签："
  />
}

const Publisher = ({ inspirationId, value = [], onChange, keywords }) => { // 发布者
  const [keysWords, setKeyWords] = useState('')
  const flag = useRef(true)
  const [loading, setLoading] = useState(false)
  const convert = (result) => {
    return result.map(m => ({ label: m, value: m }))
  }
  const [options, setOptions] = useState([])

  useEffect(() => {
    setKeyWords(keywords)
    fetchData()
  }, [inspirationId, keywords])

  const fetchData = async (keyword = null) => {
    try {
      setLoading(true)
      const res = await request.cget('/zhikuan/inspiration/blog/list-source-shop-names', {
        inspirationId,
        keyword: !flag.current ? keyword : keywords
      })
      if (keywords && flag.current) {
        onChange(res, keywords)
      }
      setOptions(res)
      setLoading(false)
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }

  return <AddPanelSelect
    panelLabel="成员"
    options={options}
    value={value.map(item => ({ label: item, value: item }))}
    onChange={(_values) => {
      onChange(_values)
    }}
    convert={convert}
    style={{ marginRight: '40px' }}
    label="发布者："
    loading={loading}
    type={SEARCH_TYPE.SPECIAL_REQUEST}
    searchText={keysWords}
    onSearch={(val) => {
      flag.current = false
      setKeyWords(val)
      fetchData(val)
    }}
  />
}
